'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Badge, Popover, Stack } from '@mantine/core';
export function SetLabels({ labels = [], compact = false, group = 'all' }) {
  const [now, setNow] = useState(0);
  useEffect(() => {
    const tick = () => setNow(Date.now());
    const first = setTimeout(tick, 0);
    const timer = setInterval(tick, 60000);
    return () => {
      clearTimeout(first);
      clearInterval(timer);
    };
  }, []);
  const current = labels
    .filter(l => l.key && Date.parse(l.valid_until) > now)
    .filter(l => group === 'all' || (group === 'regular' ? l.group === 'age' : l.group !== 'age'))
    .sort((a, b) => a.priority - b.priority);
  if (!current.length) return null;
  const visible = compact ? current.slice(0, 3) : current;
  return (
    <>
      {visible.map(l => {
        return (
          <Badge
            key={l.key}
            component={Link}
            href={`/?labels=${encodeURIComponent(l.key)}`}
            className="theme-badge-clickable"
            variant="light"
            color={l.color}
            radius={compact ? 'sm' : 'xl'}
            size={compact ? 'sm' : 'md'}
            style={{
              height: compact ? undefined : 28,
              cursor: 'pointer',
              textTransform: 'none',
              position: 'relative',
              zIndex: 3,
              ...(l.key === '18-plus' && {
                backgroundColor: '#f8f9fa',
                color: compact ? '#66707a' : '#868e96',
                fontWeight: 500,
                border: '1px solid #e9ecef',
              }),
            }}
            aria-label={`Show ${l.title} sets`}
          >
            {l.title}
          </Badge>
        );
      })}
      {current.length > visible.length && (
        <Popover width={260} withArrow>
          <Popover.Target>
            <Badge
              component="button"
              type="button"
              style={{ cursor: 'pointer', position: 'relative', zIndex: 3 }}
              aria-label="More LEGO labels"
            >
              +{current.length - visible.length}
            </Badge>
          </Popover.Target>
          <Popover.Dropdown>
            <Stack gap="xs">
              {current.slice(visible.length).map(l => (
                <Badge
                  key={l.key}
                  component={Link}
                  href={`/?labels=${encodeURIComponent(l.key)}`}
                  color={l.color}
                  variant="light"
                  style={{ textTransform: 'none', cursor: 'pointer' }}
                  aria-label={`Show ${l.title} sets`}
                >
                  {l.title}
                </Badge>
              ))}
            </Stack>
          </Popover.Dropdown>
        </Popover>
      )}
    </>
  );
}
